export const ROUTES = {
  home: '/',
  tools: '/ferramentas',
  mergePdf: '/merge-pdf',
  splitPdf: '/split-pdf',
  compressPdf: '/compress-pdf',
  pdfToJpg: '/pdf-to-jpg',
  jpgToPdf: '/jpg-to-pdf',
  rotatePdf: '/rotate-pdf',
  deletePdfPages: '/delete-pdf-pages',
  signPdf: '/sign-pdf',
  about: '/about',
  privacy: '/privacy',
  terms: '/terms',
} as const

export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES]
